// @flow

import React, { type Node, type ComponentType, useLayoutEffect, useRef, useEffect, useState, useCallback } from 'react';
import ClipboardJS from 'clipboard';

type ChildrenProps = {|
  copied: bool,
  copy: () => void,
|};

type Props = {
  as: ComponentType<{}>,
  delay: number,
  value: string,
  children: Node | (ChildrenProps) => Node,
};

export function DelayedFeedbackCopy({ as: AsComponent, delay=1500, value, children, ...rest }: Props): Node {
  const ref = useRef();

  const [copied, setCopied] = useState(false);
  const [timeoutId, setTimeoutId] = useState();

  useLayoutEffect(() => {
    if (ref.current) {
      new ClipboardJS(ref.current);
    }
  }, [ref.current]);

  useEffect(() => {
    return () => clearTimeout(timeoutId);
  }, [timeoutId]);

  const copy = useCallback(() => {
    setCopied(true);
    setTimeoutId(setTimeout(() => setCopied(false), delay));
  }, [delay, setTimeoutId, setCopied]);

  return (
    <AsComponent {...rest} data-clipboard-text={value} ref={ref}>
      {typeof children === 'function'
        ? children({ copy, copied })
        : children
      }
    </AsComponent>
  );
}
